import http from "./client";

async function contact(courseId: string | number, lessonId: string | number, message: string) {
  const response = await http.post('/api/proctoring/contact', {
    message,
  }, {
    params: {
      id: lessonId,
      course_id: courseId,
    }
  })

  return response.data;
}

async function create(courseId: string | number, lessonId: string | number) {
  const response = await http.post('/api/proctoring/create', {}, {
    params: {
      id: lessonId,
      course_id: courseId,
    }
  });
  return response.data;
}

async function record(courseId: string | number, lessonId: string | number) {
  const response = await http.post('/api/proctoring/record', {}, {
    params: {
      id: lessonId,
      course_id: courseId,
    }
  });
  return response.data;
}

async function violation(courseId: string | number, lessonId: string | number, type: string, time: string) {
  const response = await http.post('/api/proctoring/violation', {
    time: time,
    type: type,
  }, {
    params: {
      id: lessonId,
      course_id: courseId,
    }
  })
}

const proctoring = {
  contact, create, record, violation
}

export default proctoring;